import React from 'react';

// ENUMS
import { TooltipOrigins } from '../../enums/tooltips';

// INTERFACES
import { ITooltipProps } from '../../interfaces/Tooltip.interface';

// UTILS
import { renderHtml } from '../../utils/html';

// STYLES
import { Container, isResponsiveFunction, TooltipContent } from './styles';

const Tooltip: React.FC<ITooltipProps> = ({
  title,
  active,
  origin = TooltipOrigins.CARD,
  percentAlignSpan = '50%',
  children
}: ITooltipProps) => {
  const renderTitle = () => {
    return <span {...renderHtml(title)} />;
  };

  return (
    <Container origin={origin} active={active}>
      {children}
      {title?.length > 31 &&
        (origin == TooltipOrigins.CARD || TooltipOrigins.ICON) &&
        !isResponsiveFunction() &&
        renderTitle() && (
          <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
            {title}
          </TooltipContent>
        )}
      {title?.length > 19 &&
        (origin == TooltipOrigins.CARD || TooltipOrigins.ICON) &&
        isResponsiveFunction() &&
        renderTitle() && (
          <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
            {title}
          </TooltipContent>
        )}

      {title?.length > 16 && origin == TooltipOrigins.LIST && !isResponsiveFunction() && (
        <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
          {title}
        </TooltipContent>
      )}
      {title?.length > 10 && origin == TooltipOrigins.LIST && isResponsiveFunction() && (
        <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
          {title}
        </TooltipContent>
      )}

      {title?.length > 30 && origin != TooltipOrigins.RESUME_SIMULATION && !isResponsiveFunction() && (
        <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
          {title}
        </TooltipContent>
      )}
      {title?.length > 30 && origin != TooltipOrigins.RESUME_SIMULATION && isResponsiveFunction() && (
        <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
          {title}
        </TooltipContent>
      )}

      {title?.length > 16 && origin == TooltipOrigins.RESUME_SIMULATION && !isResponsiveFunction() && (
        <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
          {title}
        </TooltipContent>
      )}
      {title?.length > 10 && origin == TooltipOrigins.RESUME_SIMULATION && isResponsiveFunction() && (
        <TooltipContent percentAlignSpan={percentAlignSpan} origin={origin} length={title?.length * 1.5 || 1}>
          {title}
        </TooltipContent>
      )}
      {origin === TooltipOrigins.TIMELINE && renderTitle()}
    </Container>
  );
};

export default Tooltip;
